import { FC } from 'react';

import { ToggleYearButton, ToggleYearButtonWrapper } from '../styled';

interface Props {
  toggleYearTab: (val: 'current' | 'next') => void;
  selectedYear: 'current' | 'next';
  currentYear: number;
  currentYearSelectedMonths: number;
  nextYear: number;
  nextYearSelectedMonths: number;
}

const ToggleTabPanel: FC<Props> = ({
  toggleYearTab,
  currentYear,
  nextYear,
  selectedYear,
  currentYearSelectedMonths,
  nextYearSelectedMonths,
}) => {
  return (
    <ToggleYearButtonWrapper>
      <ToggleYearButton
        type='button'
        onClick={() => toggleYearTab('current')}
        selected={selectedYear === 'current'}
      >
        {currentYear}- Seçili Dönem({currentYearSelectedMonths})
      </ToggleYearButton>
      <ToggleYearButton
        type='button'
        onClick={() => toggleYearTab('next')}
        selected={selectedYear === 'next'}
      >
        {nextYear}-Seçili Dönem({nextYearSelectedMonths})
      </ToggleYearButton>
    </ToggleYearButtonWrapper>
  );
};
export default ToggleTabPanel;
